package org.koin.ksp.generated

import org.koin.core.module.Module
import org.koin.dsl.*


public val com_essntl_features_address_data_di_AddressModule : Module get() = module {
	single() { _ -> com.essntl.features.address.data.repository.AddressRepositoryImpl(supabase=get(),addressDataSource=get()) } bind(com.essntl.features.address.domain.repository.AddressRepository::class)
	single() { _ -> com.essntl.features.address.data.supabase.AddressSupabaseDataSource(supabaseClient=get()) } bind(com.essntl.features.address.data.supabase.AddressSupabaseDataSource::class)
}
public val com.essntl.features.address.data.di.AddressModule.module : org.koin.core.module.Module get() = com_essntl_features_address_data_di_AddressModule
